import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { InputObservable, connectState } from '@y42/angular/util';
import { Observable, switchMap } from 'rxjs';
import { JobStoreModel } from '../../state';
import { JobCancellationButtonService } from './job-cancellation-button.service';

@UntilDestroy()
@Component({
  selector: 'y42-job-cancellation-button[jobRequestId]',
  templateUrl: './job-cancellation-button.component.html',
  styleUrls: ['./job-cancellation-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [JobCancellationButtonService],
})
export class JobCancellationButtonComponent {
  constructor(private readonly service: JobCancellationButtonService) {}

  @Input()
  @InputObservable()
  jobRequestId!: string;
  jobRequestId$!: Observable<string>;

  readonly state = connectState(this, {
    job: this.jobRequestId$.pipe(switchMap((id) => this.service.selectJob(id))),
    canCancel: this.jobRequestId$.pipe(switchMap((id) => this.service.selectCanCancel(id))),
    cancellationInProgress: this.jobRequestId$.pipe(switchMap((id) => this.service.selectCancellationInProgress(id))),
  });

  cancelJob(id: JobStoreModel['request_id'], path: JobStoreModel['path']) {
    this.service.cancelJob(id, path).subscribe();
  }
}
